// src/AtLeastOne.ts
var isAtLeastOne = (array) => (array?.length ?? 0) >= 1;
export {
  isAtLeastOne
};
//# sourceMappingURL=index.mjs.map